import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ModalNavigationComponent } from 'src/app/services/gui/modal/modal-navigation-component';

@Component({
  selector: 'app-user-profile-picture-upload',
  templateUrl: './user-profile-picture-upload.component.html',
  styleUrls: ['./user-profile-picture-upload.component.scss'],
  standalone: false,
})
export class UserProfilePictureUploadComponent implements OnInit, ModalNavigationComponent {
  isInModalContext: boolean;

  isDragOver: boolean;

  @ViewChild('filePicker') filePicker: ElementRef;

  constructor() {}

  ngOnInit(): void {}

  dropHandler(event) {
    this.isDragOver = false;
    event.stopPropagation();
    event.preventDefault();
    if (event.dataTransfer.items) {
      for (let i = 0; i < event.dataTransfer.items.length; i++) {
        if (event.dataTransfer.items[i].kind === 'file') {
          const file = event.dataTransfer.items[i].getAsFile();
          if (this.checkFileValid(file)) {
            this.uploadFile(file);
          }
        }
      }
    } else {
      for (let i = 0; i < event.dataTransfer.files.length; i++) {
        const f = event.dataTransfer.files[i];
        if (this.checkFileValid(f)) {
          this.uploadFile(f);
        }
      }
    }
  }

  dragOverHandler(event) {
    event.stopPropagation();
    event.preventDefault();
  }

  getDragAndDropClasses() {
    if (this.isDragOver) {
      return 'box-dragover';
    } else {
      return 'box-dragdrop';
    }
  }

  checkFileValid(f) {
    return !(!f.type || f.type.length < 2);
  }

  openFilePicker() {
    this.filePicker.nativeElement.click();
  }

  filePicked() {
    const files = this.filePicker.nativeElement.files;
    if (files && files.length > 0) {
      for (const f of files) {
        if (this.checkFileValid(f)) {
          this.uploadFile(f);
        }
      }
    }
    this.filePicker.nativeElement.value = '';
  }

  uploadFile(file: File) {}
}
